import React from "react";
import TableData from "../../../../../../../../_components/TableData";
import Modal from "../../../../../../../../_components/Modal";
import Button from "../../../../../../../../_components/Button";
import { _Input } from "../../../../../../../../_components/Input";
import { CreateNFeContext } from "../../../../Context";
import Currency from "react-currency-formatter";
import { formatDate } from "../../../../../../../../utils";
import IconButton from "../../../../../../../../_components/IconButton";

export default (props) => {
  const [data, setData] = React.useState([]);
  const context = React.useContext(CreateNFeContext);

  function removePayment(payment) {
    context.handlers.setNFePayments(
      context.nfe.payments.filter((pay, idx) => idx !== payment.idx)
    );
  }

  function handleListPayments() {
    if (context.nfe.payments) {
      setData(
        context.nfe.payments.map((pay, idx) => {
          let dueDue = pay.due_date ? (
            <React.Fragment>
              {formatDate(pay.due_date)}
              <UpdateDueDate pay={pay} />
            </React.Fragment>
          ) : (
            ""
          );
          pay.idx = idx;
          return {
            name: pay.name,
            idx,
            value: (
              <React.Fragment>
                <Currency quantity={pay.value} symbol="R$ " currency="brl" />
                <UpdatePrice pay={pay} />
              </React.Fragment>
            ),
            formatedDueDate: dueDue,
            actions: (
              <div>
                <IconButton
                  onClick={() => {
                    removePayment(pay);
                  }}
                  className="text-danger"
                  icon="trash-alt"
                />
              </div>
            ),
          };
        })
      );
    }
  }
  React.useEffect(handleListPayments, [
    context.nfe.total_paid,
    context.nfe.payments,
    context.nfe,
  ]);

  if (data.length > 0) {
    return (
      <TableData
        tHead={["Forma de pagamento", "Valor pago", "Vencimento", "Ações"]}
        data={data}
        tBodyKeys={["name", "value", "formatedDueDate", "actions"]}
      />
    );
  } else {
    return <span />;
  }
};

function UpdateDueDate(props) {
  const ref = React.useRef(null);
  const [show, setShow] = React.useState(false);
  const [newDate, setDate] = React.useState(null);
  const context = React.useContext(CreateNFeContext);

  function onHide() {
    setShow(false);
    setDate(null);
  }
  function onUpdate() {
    if (!newDate) {
      onHide();
      return;
    }
    let date = new Date();
    let [year, month, day] = newDate.split("-");
    date.setFullYear(year);
    date.setMonth(parseInt(month) - 1);
    date.setDate(day);
    const { payments } = context.nfe;
    payments[props.pay.idx].due_date = date;
    const { setNFePayments } = context.handlers;
    setNFePayments([]);
    setTimeout(() => {
      setNFePayments(payments);
    }, 5);
    onHide();
  }

  React.useEffect(() => {
  }, [ref.current]);
  return (
    <React.Fragment ref={ref}>
      <IconButton onClick={() => setShow(true)} icon="edit" />
      <Modal show={show} title="Atualizar Vencimento" onHide={onHide}>
        <div className="d-flex justify-content-center">
          <_Input
            onChange={(e) => {
              setDate(e.value);
            }}
            type="date"
            value={props.pay.due_date}
          />
        </div>
        <div className="d-flex justify-content-center">
          <Button onClick={onUpdate}>Atualizar</Button>
        </div>
      </Modal>
    </React.Fragment>
  );
}


function UpdatePrice(props) {
  const ref = React.useRef(null);
  const [show, setShow] = React.useState(false);
  const [value, setValue] = React.useState(0);
  const context = React.useContext(CreateNFeContext);

  function onHide() {
    setShow(false);
    setValue(null);
  }
  function onUpdate() {
    if (!value) {
      onHide();
      return;
    }
    const { payments } = context.nfe;
    payments[props.pay.idx].value = value
    const { setNFePayments, updateTotalNFe } = context.handlers;
    setNFePayments([])
    updateTotalNFe()
    setTimeout(()=>{
      setNFePayments(payments)
      updateTotalNFe()
    }, 5)
    onHide();
  }

  React.useEffect(() => {
    setValue(props.pay.value)
  }, [ref.current]);
  return (
    <React.Fragment ref={ref}>
      <IconButton onClick={() => setShow(true)} icon="edit" />
      <Modal show={show} title="Atualizar Vencimento" onHide={onHide}>
        <div className="d-flex justify-content-center">
          <_Input
            onChange={(e) => {
              setValue(e.value);
            }}
            type="currency"
            value={value}
          />
        </div>
        <div className="d-flex justify-content-center">
          <Button onClick={onUpdate}>Atualizar</Button>
        </div>
      </Modal>
    </React.Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/views/Fiscal/NFe/Issuer/NFePaymentShipping/Payments/components/PaymentsTable/index.jsx